import React, { useState, useEffect, useRef } from 'react';
import {
  Button,
  Stepper,
  Step,
  StepLabel,
  Typography,
  TextField,
  Box,
  CircularProgress
} from '@mui/material';
import ResponsiveAppBar from "../ResponsiveAppBar.js"
import ResponsiveFooter from "../ResponsiveFooter.js";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import * as constants from "../constants.js"
import { MapContainer, TileLayer, FeatureGroup } from 'react-leaflet';
import { EditControl } from 'react-leaflet-draw';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import 'leaflet-draw/dist/leaflet.draw.css';

const steps = ['Grundinformation', 'Auswahl'];

const AddRegion = () => {
  const [activeStep, setActiveStep] = useState(0);
  const [outline, setOutline] = useState([]);
  const [regionInfo, setRegionInfo] = useState({
    name: '',
  });
  const [loading, setLoading] = useState(false); // New state for loading indicator
  const navigate = useNavigate();
  const featureGroupRef = useRef();

  useEffect(() => {
    //getBreedsFromBackend()
  }, []);

  const handleNext = () => {
    if (activeStep === steps.length - 1) {
      // If it's the last step, submit the form
      handleSubmit();
    } else {
      // If it's not the last step, proceed to the next step
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    }
  };

  const handleBack = () => {
    if (activeStep === 0) {
      navigate("/");
    } else {
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
    }
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setRegionInfo({ ...regionInfo, [name]: value });
  };

  const isFormIncomplete = () => {
    return Object.values(regionInfo).some((value) => value === '');
  };

  const onCreated = (e) => {
    const { layerType, layer } = e;

    if (layerType === 'polygon') {
      var area = L.GeometryUtil.geodesicArea(layer.getLatLngs()[0]);
      // If area is larger than 25km², then do not accept the outline
      if (area > 25 * 1000 * 1000) {
        alert("Die gewähle Fläche darf die Größe von 25 Quadratkilometern nicht überschreiten.");
        layer.remove();
        const featureGroup = featureGroupRef.current;
        if (featureGroup) {
          featureGroup.clearLayers();
        }
      } else {
        setOutline(layer.getLatLngs()[0].map((latLng) => [latLng.lat, latLng.lng]));
      }
    }
  };

  const onStartDraw = (e) => {
    const { layerType } = e;

    if (layerType === 'polygon') {
      const featureGroup = featureGroupRef.current;
      if (featureGroup) {
        featureGroup.clearLayers();
      }
    }
  };

  const renderStepContent = (step) => {
    switch (step) {
      case 0:
        return (
          <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
            <TextField
              name="name"
              label="Name"
              value={regionInfo.name}
              onChange={handleInputChange}
            />
            <br></br>
            <br></br>
          </div>
        );
      case 1:
        return (
          <div id='mapContainer'>
            <MapContainer center={[48.946607, 11.404568]} zoom={8} maxZoom={18} style={{ height: '600px', width: '100%' }}>
              <TileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              />
              <FeatureGroup ref={featureGroupRef}>
                <EditControl
                  position="topright"
                  onCreated={onCreated}
                  onDrawStart={onStartDraw}
                  draw={{
                    polyline: false,
                    circle: false,
                    circlemarker: false,
                    rectangle: false,
                    marker: false,
                    edit: false,
                    remove: false
                  }}
                  edit={{
                    remove: false,
                    edit: false
                  }}
                />
              </FeatureGroup>
            </MapContainer>
          </div>
        );
      default:
        return 'Unknown step';
    }
  };

  const handleSubmit = async () => {
    setLoading(true); // Start loading
    try {
      const resp = await axios.create({
        withCredentials: true,
      }).post("//" + constants.BASE_URL + "/addRegion", {
        name: regionInfo.name,
        regionOutline: outline
      });
      navigate("/");
    } catch (error) {
      if (error.response && error.response.data && error.response.data.error) {
        alert(error.response.data.error);
      } else {
        alert("Etwas ist schiefgegangen");
      }
    } finally {
      setLoading(false); // Stop loading
    }
  };

  return (
    <div className="home">
      <ResponsiveAppBar />
      <div className="body-content">
        <br></br>
        <Stepper activeStep={activeStep}>
          {steps.map((label, index) => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>
        <br></br>

        <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
          <div style={{ width: '100%' }}>
            <Typography>{renderStepContent(activeStep)}</Typography>
            <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
              <Box mt={2}>
                {loading ? (
                  <CircularProgress />
                ) : (
                  <>
                    <Button onClick={handleBack}>
                      Zurück
                    </Button>
                    <Button
                      variant="contained"
                      onClick={handleNext}
                      disabled={
                        (activeStep !== 1 &&
                          isFormIncomplete())
                      }
                    >
                      {activeStep === steps.length - 1 ? 'Region anlegen' : 'Weiter'}
                    </Button>
                  </>
                )}
              </Box>
            </div>
          </div>
        </div>
      </div>
      <ResponsiveFooter />
    </div>
  );
};

export default AddRegion;
